import { useQuery } from '@tanstack/react-query';
import { getCustomerWishlist } from '../../api/apiStorefront';
import { useAuthContext } from '../../auth/useAuthContext';

export const useGetCustomerWishlist = () => {
  const { isAuthenticated } = useAuthContext();

  return useQuery({
    queryKey: ['customer-wishlist'],
    queryFn: async () => {
      const response = await getCustomerWishlist();
      return response?.data || [];
    },
    enabled: isAuthenticated,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });
};
